import {
  LOAD_MODAL_CONTAINER,
  CLOSE_MODAL_CONTAINER,
  LOAD_MESSAGE_MODAL,
  SET_IS_LOGGED_OUT_CHAT_ENABLED,
  CALLUS_FROM_COMPLAINTS_PAGE,
  RESET_CALLUS_FROM_COMPLAINTS_PAGE,
  SET_IS_PUI_TOPIC_SUPPORTED_ENABLED, FROM_EMAIL_PAGE,
} from '../constants/ActionTypes';

// Show Prompt up for login navigation
export const loadModalContainer = (channel, endPoint = undefined, fromComplaintsPage = false, fromEmailPage = false) => (dispatch) => dispatch({
  type: LOAD_MODAL_CONTAINER,
  payload: {
    channel, endPoint, fromComplaintsPage, fromEmailPage,
  },
});

export const closeModalContainer = () => (dispatch) => dispatch({ type: CLOSE_MODAL_CONTAINER });

// Showing message by showing Modal prompt
export const loadMessageModal = (payload) => ({
  type: LOAD_MESSAGE_MODAL,
  payload,
});

export const setLoggedOutChatEnabled = (value) => ({
  type: SET_IS_LOGGED_OUT_CHAT_ENABLED,
  payload: value,
});

// When callus clicked on complaints page in login usecase
export const callUsFromComplaintsPage = () => ({
  type: CALLUS_FROM_COMPLAINTS_PAGE,
});

// When callus clicked on complaints page in login usecase
export const resetCallUsFromComplaintsPage = () => ({
  type: RESET_CALLUS_FROM_COMPLAINTS_PAGE,
});

export const setPuiTopicEnabled = (value) => ({
  type: SET_IS_PUI_TOPIC_SUPPORTED_ENABLED,
  payload: value,
});

export const loginFromEmailPage = () => ({
  type: FROM_EMAIL_PAGE,
});
